<template>
  <div class="flex h-full w-full flex-col justify-between">
    <!-- Main content in the middle -->
    <div class="flex-grow content-center">
      <h1
        class="gc-font-title mb-10 mt-5 text-center font-text-pop-title text-text-pop-title">
        {{ $t('loyaltyButtonLabel') }}
      </h1>
      <div
        class="font-primary mb-6 text-center text-small-titles md:mb-14"
        v-html="$t('loyaltyMessage')"></div>
      <CustomInput
        id="signInEmail"
        customDivClass="signInEmail mb-4 text-xs w-full"
        customLabelClass="text-small-titles font-primary"
        customInputClass="w-full mt-1 h-[46px]"
        :label="$t('general.email')"
        :maxLength="255"
        placeholder="john.doe@mail.com"
        :defaultValue="email"
        :hasError="emailWarning"
        @update:text="fillEmail"
        @blur="handleEmailBlur" />

      <!-- <CustomInput
        id="password"
        :label="$t('general.password')"
        customDivClass="relative mb-4 text-xs w-full"
        customLabelClass="text-small-titles"
        customInputClass="w-full mt-1 h-[46px]"
        :type="isPasswordVisibleValue ? 'text' : 'password'"
        placeholder="Enter your password"
        :iconButton="isPasswordVisibleValue ? 'eye-off' : 'eye'"
        @click="togglePasswordField"
        @update:text="fillPassword"
        customButtonIconClass="px-3 text-sm right-0 text-gray-400 !top-3"
        autoComplete="current-password" /> -->

      <div class="flex justify-end align-middle">
        <!-- <a
          href="#"
          class="cursor-pointer text-sm text-brand underline"
          @click="openRecoverPassword">
          {{ $t('general.forgotPassword') }} ?
        </a> -->

        <label class="flex items-center">
          <span class="font-primary text-sm">
            {{ $t('general.rememberMe') }}
          </span>
          <input type="checkbox" class="ml-2" v-model="rememberMe" />
        </label>
      </div>

      <div class="font-primary mt-6 flex justify-center text-sm">
        {{ $t('general.notMemberYet') }} ?
        <a
          href="#"
          class="ml-1 cursor-pointer text-brand underline"
          @click="signUp">
          {{ $t('general.signUp') }}
        </a>
      </div>
    </div>
    <div class="mb-5 mt-10 flex justify-around gap-2">
      <CustomButton
        class="signInButton"
        width="w-full"
        :label="$t('general.done')"
        @click="doLogin" />
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, onUnmounted } from 'vue';
import { useUserProfile } from '@stores/userProfile.store';
import CustomInput from '@/components/customComponents/CustomInput.vue';
import CustomButton from '@/components/customComponents/CustomButton.vue';
import { useRoute } from 'vue-router';
import { validateEmail } from '@/utils/inputValidation';
import { useCookiesStore } from '@stores/cookies.store';

const route = useRoute();

const emit = defineEmits([
  'openRecoverPassword',
  'openSignUp',
  'showLoggedInModal',
  'close',
  'isSignInEmptyOrValid',
]);
const userProfile = useUserProfile();
// const isPasswordVisibleValue = ref(false);

const email = ref('');
// const pwd = ref('');

const emailWarning = ref(false);
// const passwordWarning = ref(false);

const rememberMe = ref(false);

const handleKeydown = (event) => {
  if (event.key === 'Enter') {
    event.preventDefault();
    doLogin();
  }
};

onMounted(() => {
  if (
    route.query.lt &&
    route.query.ltl &&
    !document.cookie.includes('loyalty_user')
  ) {
    email.value = route.query.ltl;
  }
  // Add global keydown listener
  window.addEventListener('keydown', handleKeydown);
});

onUnmounted(() => {
  // Remove global keydown listener
  window.removeEventListener('keydown', handleKeydown);
});

const signUp = () => {
  emit('openSignUp');
};

const doLogin = async () => {
  if (!email.value) {
    emit('close');
    return;
  }

  if (!validateEmail(email.value).isValid) {
    emailWarning.value = true;
    return;
  }

  const userData = {
    login: email.value,
    // password: pwd.value,
  };
  const response = await userProfile.doLogin(userData);

  if (response.data.status) {
    emit('showLoggedInModal');

    if (rememberMe.value) {
      const userCookieData = {
        email: email.value,
        firstName: response.data.first_name,
      };

      const cookiesStore = useCookiesStore();
      cookiesStore.setCookie('loyalty_user', userCookieData);
    }
  } else {
    emailWarning.value = true;
    // passwordWarning.value = true;
  }
};

// const fillPassword = (value) => {
//   pwd.value = value;
//   passwordWarning.value = false;
// };

const fillEmail = (value) => {
  email.value = value;
  // Only clear error when typing (validation happens onBlur)
  if (emailWarning.value) {
    emailWarning.value = false;
  }
  emit('isSignInEmptyOrValid', !value || validateEmail(value).isValid);
};

const handleEmailBlur = () => {
  // Validate only when user leaves the field
  if (!email.value) {
    emailWarning.value = false; // Empty is allowed (not mandatory)
  } else if (!validateEmail(email.value).isValid) {
    emailWarning.value = true;
  } else {
    emailWarning.value = false;
  }
};

// const togglePasswordField = () => {
//   isPasswordVisibleValue.value = !isPasswordVisibleValue.value;
// };
</script>

<style scoped>
.warning input {
  @apply border-error text-error;
}

.warning input::placeholder {
  @apply text-error;
}
</style>
